import React, { useState } from 'react'
import { Parallax } from 'react-parallax'

import SanferRedLabel from '../../../baseComponents/SanferRedLabel'
import PageTitle from '../../../baseComponents/PageTitle'

import sanferBG from '../../../assets/images/Fundacion_Sanfer-min.png'
import respBG from '../../../assets/images/Imagen_responsabilidad_social-min.png'
import arrow from '../../../assets/images/svg_icons/arrow.svg'

const Foundation = props => {
  const { texts } = props
  const { foundation } = props.data
  const [banner, setBanner] = useState(sanferBG)
    , [active, setActive] = useState('sanfer')

  return <Parallax renderLayer={percent => {

    return <div className='home__foundation' style={{ opacity: percent }}>
      <div className='home__foundation-background'>
        <SanferRedLabel />
        <div className='home__foundation-image transition'
          style={{ background: `url(${banner})` }} />
      </div>
      <div className='home__foundation-container'>
        <SanferRedLabel />
        <div id='sanfer-foundation' className={`home__foundation-item transition ${active === 'sanfer' ? 'selected' : ''}`}
          onMouseEnter={() => {
            setActive('sanfer')
            setBanner(sanferBG)
          }}>
          <PageTitle title={foundation.sanfer.title} label={foundation.sanfer.redLabel} />
          <div className='gray-color' dangerouslySetInnerHTML={{ __html: foundation.sanfer.paragraphs }} />
          <a href='https://fundacionsanfer.org' target='_blank' rel='noopener noreferrer' className='home__about-block centered'>
            <span>{texts.knowMore}</span>
            <img className='arrow-left' src={arrow} alt='flecha' />
          </a>
        </div>
        <div className='gray-line' />
        <div id='responsibility-foundation' className={`home__foundation-item transition ${active === 'responsibility' ? 'selected' : ''}`}
          onMouseEnter={() => {
            setActive('responsibility')
            setBanner(respBG)
          }}>
          <PageTitle title={foundation.responsibility.title} label={foundation.responsibility.redLabel} />
          <div className='gray-color' dangerouslySetInnerHTML={{ __html: foundation.responsibility.paragraphs }} />
        </div>
      </div>
    </div>

  }} />

}

export default Foundation